import PropTypes from 'prop-types';
import classNames from 'classnames';

import Image from '../Image/Image';
import SkeletonLoader from '../SkeletonLoader/SkeletonLoader';
import DataErrorItem from '../DataErrorItem/DataErrorItem';
import Icon from '../Icon';
import { t } from '../../i18n';

import s from './CardImageItem.module.scss';

const CardImageItem = ({
    hasEditorialImage,
    image,
    isLoading = false,
    errorFetchingData = false,
    title = '',
    value = '',
    subtitle = '',
    tags = [],
    isSquare = false,
    useCover = true,
    isRectangle = false,
    modifiers = [],
    isSanctioned = false,
}) => {
    const classes = classNames(
        s.Root,
        {
            [s['Root--Square']]: isSquare,
            [s['Root--Rectangle']]: isRectangle,
        },
        modifiers.map((modifier) => s[`Root--${modifier}`])
    );

    return (
        <div className={classes}>
            <div className={s.Container}>
                {hasEditorialImage && !!image?.src && (
                    <div className={s.Image}>
                        <Image
                            {...image}
                            useCover={useCover}
                            isRectangle={isRectangle}
                        />
                    </div>
                )}
                {isLoading && (
                    <div className={s.LoaderWrapper}>
                        <SkeletonLoader />
                    </div>
                )}
                {errorFetchingData && (
                    <DataErrorItem
                        title={title}
                        description={t('general.errorFetchingData')}
                    />
                )}
                {!isLoading && !errorFetchingData && (
                    <div className={s.Text}>
                        <span className={s.Label}>{title}</span>
                        <h2 className={s.Title}>{value}</h2>
                        {subtitle && <p className={s.SubHeading}>{subtitle}</p>}
                        {!subtitle && tags.length !== 0 && (
                            <div
                                className={classNames(s.Tags, {
                                    [s.HasMultiple]: tags.length > 1,
                                })}>
                                {tags.map((tag, index) => (
                                    <div key={index} className={s.Tag}>
                                        {tag}
                                    </div>
                                ))}
                            </div>
                        )}
                        {isSanctioned && (
                            <div className={s.IconWrapper}>
                                <Icon name="Warning" className={s.Icon} />
                                <span className={s.WarningText}>
                                    {t('general.sanctioned')}
                                </span>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

CardImageItem.propTypes = {
    hasEditorialImage: PropTypes.bool,
    image: PropTypes.object,
    isLoading: PropTypes.bool,
    errorFetchingData: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    subtitle: PropTypes.string,
    tags: PropTypes.array,
    isSquare: PropTypes.bool,
    useCover: PropTypes.bool,
    isRectangle: PropTypes.bool,
    modifiers: PropTypes.array,
    isSanctioned: PropTypes.bool,
};

export default CardImageItem;
